import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { API, graphqlOperation } from 'aws-amplify'
import Button from 'antd/lib/button'
import UpdateFloorWarden from '../../GraphQL/UpdateFloorWarden'
import DeleteFloorWarden from '../../GraphQL/DeleteFloorWarden'
import Modal from 'antd/lib/modal'
import { setIsAcknowledged, setIsFloorWarden } from '../../redux/floorWarden/actions'
import { updateUserRoles } from '../../redux/app/actions'
import { EMERGENCY_RESPONSE_TEAM, FLOOR_WARDEN } from './enums'

const GetFloorWarden = `query getFloorWarden($email: String) {
    getFloorWarden(email: $email) {
        email
        buildingName
        buildingId
        firstName
        floor
        lastName
        phone
        position
        propertyId
        suite
        tenantId
        tenantName
        type
        acknowledged
        version
    }
}`

const acceptAcknowledgement = (user, version) => {
    let floorWardenData = {
        input: {
            email: user.email,
            acknowledged: true,
        },
        version: version,
    }

    UpdateFloorWarden(floorWardenData).then((res) => {
        if (res.errors) {
            console.log('res: ', res.errors)
            return null
        }
        setIsAcknowledged(true)
    })
}

const declineAcknowledgement = (user) => {
    DeleteFloorWarden(user.email).then((res) => {
        if (res.errors) {
            console.log('error: ', res.errors)
            return null
        }
        updateUserRoles(
            user.roles.filter((role) => role !== FLOOR_WARDEN && role !== EMERGENCY_RESPONSE_TEAM)
        )
        setIsFloorWarden(false, false, null, 'Become a Floor Warden')
    })
}

const AcknowledgeForm = () => {
    const user = useSelector((state) => state.app.user)
    const version = useSelector((state) => state.floorWarden.version)
    const acknowledged = useSelector((state) => state.floorWarden.acknowledged)
    const position = useSelector((state) => state.floorWarden.position)
    const isFloorWarden = useSelector((state) => state.floorWarden.isFloorWarden)

    useEffect(() => {
        async function fetch() {
            try {
                const response = await API.graphql(graphqlOperation(GetFloorWarden, { email: user.email }))
                if (response.data.getFloorWarden) {

                    let _data = response.data.getFloorWarden

                    let position = typeof _data.position === 'string' ? _data.position : ''
    
                    setIsFloorWarden(
                        true,
                        _data.acknowledged,
                        position,
                        _data.version,
                        `You are a ${position} for Floor ${_data.floor}`
                    )
                }
            } catch (response) {
                console.error(response)
            }
        }

        if (user.email) {
            fetch()
        } else {
            console.error('Could not find a user')
        }
    }, [user.email])

    let _position = position ? position : 'Floor Warden'

    return (
        <Modal
            title={'Floor Warden'}
            visible={!acknowledged && isFloorWarden}
            width={'60%'}
            onCancel={() =>
                Modal.confirm({
                    title: 'Are you sure?',
                    content: `Please note that closing this window will decline the ${_position} position.`,
                    okText: 'Yes',
                    okType: 'danger',
                    cancelText: 'No',
                    onOk() {
                        declineAcknowledgement(user)
                    },
                })
            }
            footer={false}
        >
            <div>
                <div style={{ textAlign: 'center', marginBottom: '2em' }}>
                    <span>You have been assigned as a {_position}.</span> <br />
                    <span>
                        Please note that the {_position} position is voluntary. Would you like to
                        accept this position?
                    </span>
                </div>
                <Button type="danger" ghost onClick={() => declineAcknowledgement(user)}>
                    Decline
                </Button>
                <Button
                    type="primary"
                    style={{ float: 'right' }}
                    onClick={() => acceptAcknowledgement(user, version)}
                >
                    Accept
                </Button>
            </div>
        </Modal>
    )
}

export default AcknowledgeForm
